module.exports = __webpack_public_path__ + "images/suzuki356869948272daf1fc5e8bcbe2a9bf8c.png";